import { useCallback } from 'react'
import { dia, shapes } from '@joint/core'

import { useFloorStore } from '../../../../map-editor-shared/store/floorStore'

interface UseFloorExportProps {
  graph: dia.Graph | null
}

interface UseFloorExportReturn {
  prepareFloorsForExport: (lotId: string) => Array<{
    name: string
    order: number
    graph: dia.Graph
  }>
}

export function useFloorExport(props: UseFloorExportProps): UseFloorExportReturn {
  const { graph } = props

  const { currentFloor } = useFloorStore()

  // ======================
  // Helper: Prepare all floors for export (multi-floor handling)
  // ======================
  const prepareFloorsForExport = useCallback(
    (lotId: string) => {
      const lotFloors = useFloorStore.getState().getFloorsByLotId(lotId)

      return lotFloors.map(floor => {
        // If this is the current floor, use the active graph
        if (floor.id === currentFloor && graph) {
          return {
            name: floor.name,
            order: floor.order,
            graph: graph,
          }
        }

        // For other floors, restore graph from stored JSON
        // IMPORTANT: Must provide cellNamespace to restore cells correctly
        const floorGraph = new dia.Graph({}, { cellNamespace: shapes })
        if (floor.mapData?.graphJson) {
          try {
            floorGraph.fromJSON(floor.mapData.graphJson)
          } catch (error) {
          }
        }

        return {
          name: floor.name,
          order: floor.order,
          graph: floorGraph,
        }
      })
    },
    [currentFloor, graph]
  )

  return {
    prepareFloorsForExport,
  }
}
